import { Component, Inject, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import {
  PL_API_CONFIG,
  PlAPIConfig,
  selectCurrentUser,
  User,
} from 'pl-core-services';

@Component({
  selector: 'pl-need-assistance-card',
  templateUrl: './need-assistance-card.component.html',
  styleUrls: ['./need-assistance-card.component.scss'],
})
export class NeedAssistanceCardComponent {
  private readonly destroyRef = inject(DestroyRef);

  private currentUser: User;

  constructor(
    @Inject(PL_API_CONFIG) private config: PlAPIConfig,
    private store: Store,
    private http: HttpClient
  ) {
    this.store
      .select(selectCurrentUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        this.currentUser = user;
      });
  }

  openSupportChat(): void {
    const zenDeskWidget = (window as any).zE;
    if (typeof zenDeskWidget !== 'function') return;

    this.http.get(`${this.config.gateway}/auth/token/zendesk`).subscribe({
      next: (resp: any) => {
        if (resp.exists_in_zendesk && this.currentUser) {
          zenDeskWidget(
            'messenger',
            'loginUser',
            (callback: (arg: any) => void) => {
              callback(resp.jwt);
            }
          );
          zenDeskWidget('messenger:set', 'conversationFields', [
            { id: '30009313905171', value: this.currentUser.email ?? '' },
            {
              id: '26287517467923',
              value: `${this.currentUser.first_name ?? ''} ${
                this.currentUser.last_name ?? ''
              }`,
            },
          ]);
        }
        zenDeskWidget('messenger', 'show');
        zenDeskWidget('messenger', 'open');
      },
      error: () => {
        // Token fetch failed — still attempt to open the widget unsigned
        zenDeskWidget('messenger', 'show');
        zenDeskWidget('messenger', 'open');
      },
    });
  }
}
